import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { auth } from './api';
import { getReferralContext } from './referralTracker';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('le_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const me = await auth.me();
      setUser(me);
    } catch {
      localStorage.removeItem('le_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { token, user: u } = await auth.login({ email, password });
    localStorage.setItem('le_token', token);
    setUser(u);
    return u;
  };

  const signup = async (email, password, name) => {
    // Attach acquisition context so admin can attribute the signup back to
    // the landing page / referrer / UTM. All fields are optional and safe
    // to omit if sessionStorage is unavailable.
    const referral = getReferralContext();
    const payload = { email, password, name };
    if (referral && Object.keys(referral).length) payload.referral = referral;
    const { token, user: u } = await auth.signup(payload);
    localStorage.setItem('le_token', token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('le_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
